import { Box, Typography } from '@mui/material';
import { PaperFrameStyled } from '@/components/common/paperFrameStyled';
import { AverageSpending } from '@/interfaces/cashFlow';
import ChartCurrencyTitle from '@/components/charts/chartCurrencyTitle';

const CashFlowAverageSpending: React.FC<{ data: AverageSpending }> = ({
  data,
}) => {
  const title = (
    <Typography
      variant='h5'
      sx={{
        fontSize: '24px',
        lineHeight: '133.4%',
      }}
    >
      Average Spending
    </Typography>
  );

  const content = (
    <Box
      sx={{
        display: 'flex',
        padding: '0 24px 24px 24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '16px',
        alignSelf: 'stretch',
        flexGrow: 1,
      }}
    >
      <ChartCurrencyTitle
        totalValue={data.amount}
        totalValueText='Per month'
        otherValue={data.change.amount}
        percentage={data.change.percentage}
        compareText='Last month'
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '4px',
          flex: '1 0 0',
          alignSelf: 'stretch',
        }}
      >
        <Typography
          variant='body2'
          sx={{
            color: 'text.secondary',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '143%',
            letterSpacing: '0.17px',
          }}
        >
          Top spending category
        </Typography>
        <Box
          sx={{
            display: 'flex',
            maxWidth: '567px',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Typography
            variant='subtitle1'
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '175%',
              letterSpacing: '0.15px',
            }}
          >
            {data.topSpendingCategory}
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <PaperFrameStyled
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          padding: '24px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '24px',
          alignSelf: 'stretch',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignSelf: 'stretch',
          }}
        >
          {title}
        </Box>
      </Box>
      {content}
    </PaperFrameStyled>
  );
};

export default CashFlowAverageSpending;
